export const SIGNIN_PATH = '/signin'
export const SIGNUP_PATH = '/signup'
export const RESETPASSWORD_PATH = '/reset_password'
